import { Box } from "@mui/material";
import React, { useRef, useState } from "react";
import UploadHeader from "./header";
import { useFileUpload } from "../../hooks";

const UploadImageFile = () => {
  const { uploadProgress, uploadComplete, uploadError, uploadFile } =
    useFileUpload();
  const inputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    // if (file) {

    //   uploadFile(file);
    // }
    if (file) {
      const result = await uploadFile(file);

      if (result?.data.fileSrc) {
        setUploadedFile(result.data); // ✅ Store uploaded file info
      }
    }
  };

  const btn = {
    show: true,
    text: "Upload Image",
    type: "contained",
    callBack: () => {
      inputRef.current && inputRef.current.click();
    },
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <UploadHeader title={"Image Upload"} btn={btn} />

      {/* Hidden input - must be in the DOM */}
      <input
        ref={inputRef}
        type="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Box sx={{ flex: "1 0 0", overflow: "auto", p: 2 }}>
        {uploadedFile?.fileSrc ? (
          <Box
            sx={{
              maxWidth: 300,
              boxShadow: 3,
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "background.paper",
              mx: "auto",
            }}
          >
            <Box
              component="img"
              src={uploadedFile.fileSrc}
              alt={uploadedFile.originalName}
              sx={{
                width: "100%",
                height: 200,
                objectFit: "cover",
                display: "block",
              }}
            />
            <Box sx={{ p: 1.5, textAlign: "center" }}>
              <p
                style={{
                  margin: 0,
                  fontWeight: 600,
                  fontSize: "1rem",
                  wordBreak: "break-word",
                }}
              >
                {uploadedFile.originalName}
              </p>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              textAlign: "center",
              color: "text.secondary",
              mt: 4,
              fontStyle: "italic",
            }}
          >
            No image uploaded yet
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default UploadImageFile;
